module.exports = __webpack_public_path__ + "img/wewantyou.27e98435.png";